import type { SVGProps } from 'react';

const SvgRanking01 = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 40 54' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M30.0855 16.6028C27.1219 14.8593 23.683 13.8425 20 13.8425C16.2186 13.8425 12.6954 14.9154 9.67964 16.7461C3.886 20.2628 0 26.6283 0 33.9212C0 45.0103 8.95427 53.9999 20 53.9999C31.0457 53.9999 40 45.0103 40 33.9212C40 26.5295 36.0099 20.0882 30.0855 16.6028Z'
      fill='white'
    />
    <path
      d='M20.0004 51.7689C29.8188 51.7689 37.7782 43.7782 37.7782 33.9212C37.7782 24.0642 29.8188 16.0735 20.0004 16.0735C10.182 16.0735 2.22266 24.0642 2.22266 33.9212C2.22266 43.7782 10.182 51.7689 20.0004 51.7689Z'
      fill='#FFE05F'
    />
    <path
      d='M20.0003 47.307C27.3641 47.307 33.3336 41.314 33.3336 33.9212C33.3336 26.5284 27.3641 20.5354 20.0003 20.5354C12.6365 20.5354 6.66699 26.5284 6.66699 33.9212C6.66699 41.314 12.6365 47.307 20.0003 47.307Z'
      fill='#FFB814'
    />
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.15}
    >
      <path
        d='M20.0003 47.307C27.3641 47.307 33.3336 41.314 33.3336 33.9212C33.3336 26.5284 27.3641 20.5354 20.0003 20.5354C12.6365 20.5354 6.66699 26.5284 6.66699 33.9212C6.66699 41.314 12.6365 47.307 20.0003 47.307Z'
        fill='#FFB814'
      />
    </g>
    <path
      d='M19.4632 41.3056V30.1508L16.3049 31.9678L15.1113 29.9562L19.7525 27.365H21.9285V41.3056H19.4632Z'
      fill='white'
    />
    <path
      d='M19.4068 4.01153L14.9198 9.64277C14.7376 9.87138 14.4158 9.93091 14.1644 9.78246L8.03424 6.16221C7.58512 5.89698 7.04024 6.30755 7.16846 6.81458L9.49178 16.0017C9.58673 16.3772 10.0042 16.5493 10.3416 16.3614C13.2063 14.7661 16.4923 13.8427 20.0004 13.8427C23.414 13.8427 26.618 14.7162 29.4281 16.2322C29.7653 16.4141 30.1775 16.2408 30.2717 15.8684L32.5613 6.81456C32.6895 6.30753 32.1446 5.89696 31.6955 6.16219L25.5652 9.78245C25.3139 9.93088 24.9921 9.87137 24.8099 9.64276L20.3227 4.01151C20.088 3.71687 19.6416 3.71689 19.4068 4.01153Z'
      fill='#FFE05F'
    />
    <path
      d='M19.9443 2.69984C20.6869 2.69984 21.289 2.09553 21.289 1.34988C21.289 0.604406 20.6869 0 19.9443 0C19.2016 0 18.5996 0.604406 18.5996 1.34988C18.5996 2.09553 19.2016 2.69984 19.9443 2.69984Z'
      fill='#FFE05F'
    />
    <path
      d='M33.871 2.19873C33.1283 2.19873 32.5264 2.80314 32.5264 3.54861C32.5264 4.29426 33.1283 4.89857 33.871 4.89857C34.6136 4.89857 35.2157 4.29426 35.2157 3.54861C35.2157 2.80314 34.6136 2.19873 33.871 2.19873Z'
      fill='#FFE05F'
    />
    <path
      d='M7.47441 3.54861C7.47441 2.80314 6.87238 2.19873 6.12974 2.19873C5.3871 2.19873 4.78516 2.80314 4.78516 3.54861C4.78516 4.29426 5.3871 4.89857 6.12974 4.89857C6.87238 4.89857 7.47441 4.29426 7.47441 3.54861Z'
      fill='#FFE05F'
    />
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.2}
    >
      <path
        d='M19.4068 4.01153L14.9198 9.64277C14.7376 9.87138 14.4158 9.93091 14.1644 9.78246L8.03424 6.16221C7.58512 5.89698 7.04024 6.30755 7.16846 6.81458L9.49178 16.0017C9.58673 16.3772 10.0042 16.5493 10.3416 16.3614C13.2063 14.7661 16.4923 13.8427 20.0004 13.8427C23.414 13.8427 26.618 14.7162 29.4281 16.2322C29.7653 16.4141 30.1775 16.2408 30.2717 15.8684L32.5613 6.81456C32.6895 6.30753 32.1446 5.89696 31.6955 6.16219L25.5652 9.78245C25.3139 9.93088 24.9921 9.87137 24.8099 9.64276L20.3227 4.01151C20.088 3.71687 19.6416 3.71689 19.4068 4.01153Z'
        fill='#F9AA0D'
      />
      <path
        d='M19.9443 2.69984C20.6869 2.69984 21.289 2.09553 21.289 1.34988C21.289 0.604406 20.6869 0 19.9443 0C19.2016 0 18.5996 0.604406 18.5996 1.34988C18.5996 2.09553 19.2016 2.69984 19.9443 2.69984Z'
        fill='#F9AA0D'
      />
      <path
        d='M33.871 2.19873C33.1283 2.19873 32.5264 2.80314 32.5264 3.54861C32.5264 4.29426 33.1283 4.89857 33.871 4.89857C34.6136 4.89857 35.2157 4.29426 35.2157 3.54861C35.2157 2.80314 34.6136 2.19873 33.871 2.19873Z'
        fill='#F9AA0D'
      />
      <path
        d='M7.47441 3.54861C7.47441 2.80314 6.87238 2.19873 6.12974 2.19873C5.3871 2.19873 4.78516 2.80314 4.78516 3.54861C4.78516 4.29426 5.3871 4.89857 6.12974 4.89857C6.87238 4.89857 7.47441 4.29426 7.47441 3.54861Z'
        fill='#F9AA0D'
      />
    </g>
  </svg>
);
export default SvgRanking01;
